import { render, staticRenderFns } from "./UpdateContactInformation.vue?vue&type=template&id=174f742b"
import script from "./UpdateContactInformation.vue?vue&type=script&lang=js"
export * from "./UpdateContactInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports